import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import teamService from './teamService';
import { setAlertError } from '../alert/alertSlice';

export const removeTeamFromEvent = createAsyncThunk(
  'team/removeTeamFromEvent',
  async (data, thunkAPI) => {
    return await teamService
      .removeTeamFromEvent(data.eventId, data.teamId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

export const updateTeamStatus = createAsyncThunk(
  'team/updateTeamStatus',
  async (data, thunkAPI) => {
    return await teamService
      .updateTeamStatus(data.eventId, data.teamId, data.status, data.reason)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

export const teamSlice = createSlice({
  name: 'teams',
  initialState: {
    team: null,
    teams: [],
    updatingTeamStatus: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(removeTeamFromEvent.fulfilled, (state, action) => {
        state.removingTeam = false;
        state.teams = action.payload;
      })
      .addCase(removeTeamFromEvent.rejected, (state, action) => {
        state.removingTeam = false;
        state.teams = [];
      })
      .addCase(removeTeamFromEvent.pending, (state, action) => {
        state.removingTeam = true;
        state.teams = [];
      })
      .addCase(updateTeamStatus.fulfilled, (state, action) => {
        state.updatingTeamStatus = false;
        state.teams = action.payload?.teams || action.payload;
      })
      .addCase(updateTeamStatus.rejected, (state, action) => {
        state.updatingTeamStatus = false;
      })
      .addCase(updateTeamStatus.pending, (state, action) => {
        state.updatingTeamStatus = true;
      });
  }
});

export default teamSlice.reducer;
